export default {
    SPECIFICATION: 'Design ditt eget produkt',
    FRONT_VIEW: 'Sett fra innsiden',
    OUTSIDE_VIEW: 'Vis fra utsiden',
    CLICK_TO_EDIT: 'Klikk på bildene for å gjøre valgene dine',
    EDIT: 'REDIGER',
    OK: 'OK',
    SELECTED_COLOR: 'VALGT FARGE',
    NAME: 'Navn',
    RENOLIT: 'Renolit',
    COLOR_PALETTE: 'Fargekart',
    SEARCH: 'Søk',
    ART_NR: 'Kunstnummer',
    RAL: 'RAL',
    PRICE: 'Pris',
    ORNAMENT: 'Ornament',
    SELECT_GLASS_SUBHEADER: "Velg glass for hver side av glasskassetten",
    SELECT_GLASS_SUBHEADER_INFO: 'Viktig informasjon for deg som ønsker helglassløsninger! Glass som går under 60 cm fra gangflaten må være personsikkerhetsglass. Det vil si herdet eller laminert glass. Denne regelen gjelder både innvendig og utvendig',
    MULLIONS_N_DIVIDERS: "Sprosse og midtpost",
    MULLIONS: "Senterstolpe",
    MUNTINS: "Sprosse",
    HORIZONTAL: 'Liggende',
    VERTICAL: 'Stående',
    SIZE: 'Bredde',
    INSIDE_COLOR: 'Innvendig farge',
    OUTSIDE_COLOR: 'Utvendig farge',
    GLAZING: 'Glasskassett',
    GLASS: 'Glass',
    HANDLES: 'Håndtak',
    ACTIVE_SASH_SIDE: 'Hengende',
    FIXED_SASHES_OPTIONS: 'Fast-i-fast',
    HINGE_SIDE: 'Hengende',
    SEAL_COLOR: 'Farge på tetningslisten',
    ACCESSORIES: 'Valgfritt',
    ACCESSORY: 'Valgfritt',
    UNITS: 'dm/mm',
    UNITS_ROOF_WINDOW: 'Modul/millimeter',
    BOTTOM_PANEL: 'Parapet',
    QUANTITY: 'Antall',
    PER_ITEM: 'Per enhet',
    VAT: 'Inkludert moms',
    ADD_TO_CART: 'LEGG TIL I HANDLEKURVEN',
    SAVE_CHANGES: 'Lagre endringene',
    RESET_COLOR: 'Tilbakestill farge',
    CHANGE_SERIES: 'Endre serie',
    WIDTH: 'Bredde',
    HEIGHT: 'Høyde',
    NONE_SELECTED: 'Ingen valgt',
    ORDINARY_PRICE: 'Målpris',
    PACKET: 'Utstyrspakke',
    SAVING: 'Du sparer',
    INITIAL: 'Ingen',
    WHY_PACKET: 'HVORFOR SKAL DU VELGE DENNE PAKKEN?',
    VALUE: 'Verdi',
    SAVE_MONEY: 'Velg utstyrspakke og spar penger',
    HINGE_TYPE: 'Beslag',
    CHOOSE_BEST_SOLUTION: 'Velg den løsningen som passer best',
    WINDOW_TILT_HINGE_SIDE: 'Hengende',
    NO_PRICE: 'INGEN PRIS',
    DIMENSIONS_ERROR: '*Angitte dimensjoner kan ikke velges, prøv andre dimensjoner eller kontakt oss på 0431-37 14 00*',
    BLINDS_ERROR: 'Prislisten for persienner er utenfor rekkevidde',
    APRIS: 'Til pris',
    CLASSIC: 'Ingen utstyrspakke valgt',
    DEFAULT_PACKET: 'Ingen tilleggsutstyr',
    MULTI_PACKETS: 'FLERE PAKKER',
    MULLIONS_NOTE_WINDOWDOOR_RESTRICTION: 'Når bredden overstiger 1000 mm, må du ha en horisontal midtstolpe for å sikre produktets styrke. Ta kontakt med oss hvis du ønsker et tilbud med en annen glassløsning',
    MULLIONS_NOTE_PART_1: "Merk!",
    MULLIONS_NOTE_PART_2: "Ta kontakt med oss hvis du har ønsker om plassering av sprossene",
    MULLIONS_NOTE_PART_3: "her",
    MULLIONS_NOTE_PART_4: "Vi hjelper deg",
    DIMENSION_INFO_HEADER: 'Beskrivelse av dimensjoner',
    DIMENSION_INFO_HEADER_MODAL: "Forklaring av dimensjoner",
    DIMENSION_INFO: 'Nedenfor finner du instruksjoner om ulike konstruksjoner og deres former. Det er mulig å sette verdien "0" for å få riktig konstruksjon.',
    CASEMENT_INFO_BUTTON: 'Jeg forstår og vil fortsette',
    CASEMENT_INFO_HEADER_MODAL: "Vær oppmerksom!",
    CASEMENT_INFO: 'Produktet kan kun produseres med vippefunksjon og uten sidehenging. Håndtaket er plassert i overkant som vist nedenfor. Hvis du ønsker et håndtak på siden, kan du enkelt endre det under HANDLE i konfiguratoren',
    NEXT_STEP: 'Neste',
    PREV_STEP: 'Forrige',
    SPROJS_LINE: 'Linje opp stolper',
    SPROJS_LINE_DESCRIPTION: 'Velg om du vil rette opp stolpene med et annet vindu. Hvis du er usikker, ta kontakt med selgeren din',
    SPROJS_LINE_PLACEHOLDER: "Ikke linje",
    POSITION: 'Posisjon:',
    TOTAL_PRICE: 'Totalt beløp',
    RESET: "Avbryt valgmulighet",
    MIRROR_REFLECTION: 'Gående dør',
    INNER_VIEW: 'Utsikt fra innsiden',
    OUTER_VIEW: 'Utsikt fra utsiden',
    EMPTY: '',
    NOT_CHANGED: 'Ikke endret',
    COLORS: 'Farger',
    PREDEFINED_COLOR_MATCH: 'Renolit-kombinasjoner',
    CUSTOM_COLOR_MATCH: 'Enhver RAL-farge',
    DOOR_STANDARD_COLOR: 'Standardfarger',
    DOOR_HANDLES: 'Håndtak',
    HANDLE_COLOR: 'Håndtaksfarge',
    HANDLE_OPTIONS: 'Alternativer for håndtak',
    DOOR_APPEARANCE: 'Farger',
    DELIVERY_PRICE_INFO: 'Frakt innen Norge fra',
    DELIVERY_PRICE_LINK: '/betale-og-levering#PostCodeModule',
    FREE_DELIVERY_INFO: 'Gratis frakt',
    DISCOUNT: 'Rabatt',
    YOU_SAVE: 'Du sparer',
    BUILD_YOUR_OWN_WINDOW: 'Velg den profilen du ønsker',
    COLOR: 'Farge',
    APPEARANCE: 'Utseende',
    CONFIGURATOR: 'Bygg ditt eget vindu',
    CONFIGURATOR_HELP_INFO: 'Velg kategori og underkategori for å endre vinduet til ønsket produkt',
    BTN_GO_TO_CONFIGURATOR_DEFAULT: 'Konfigurer vinduet ditt - Klikk her!',
    BTN_GO_TO_CONFIGURATOR_WINDOW: 'Konfigurer vinduet ditt - Klikk her!',
    BTN_GO_TO_CONFIGURATOR_WINDOW_DOOR: 'Konfigurer vindusdøren - klikk her!',
    BTN_GO_TO_CONFIGURATOR_FOLDING_DOOR: "Konfigurer foldedøren - klikk her!",
    BTN_GO_TO_CONFIGURATOR_SLIDING_DOOR: "Konfigurer skyvedøren - klikk her!",
    BTN_GO_TO_CONFIGURATOR_DOOR: "Konfigurer ytterdøren - klikk her!",
    BTN_GO_TO_CONFIGURATOR_ROOF_WINDOW: "Konfigurer takvinduet - klikk her!",
    PAKKER: 'UTSTYRSPAKKER',
    SERIES: 'Serie',
    PACKET_SELECTED: 'Noe tilbehør er aktivert i pakken. Hvis du vil fjerne det, bytter du pakke.',
    DIMENSION_DM: 'Dimensjoner oppgis i moduler (hele desimeter) med et fast mål på 20 mm for isolasjon. Det betyr at et vindu som f.eks. er 10x12 har et ytre rammemål på 980x1180mm.',
    DIMENSION_MM_WIDTH: 'Angi de nøyaktige ytre rammemålene i millimeter uten fradrag. Minimum bredde: {{min}}mm. Maks bredde: {{max}}mm.',
    DIMENSION_MM_HEIGHT: "Minimum høyde: {{min}}mm. Maksimal høyde: {{max}}mm",
    HANDLES_SIDE: "Håndtakets posisjon",
    LEFT: "Venstre",
    RIGHT: 'Høyre',
    TOP: 'Øverste kant',
    INISDE_GLASS: 'Innvendig glass',
    OUTISDE_GLASS: 'Utvendig glass',
    NO_NCS_INFO: 'Den angitte NCS-koden ble ikke funnet. Prøv en annen NCS-kode.',
    PRODUCT_LOOK_INFO: 'Produktbildet er kun et eksempelbilde og kan være ekstra utstyrt.',
    NCS_INFO: 'Skriv inn ønsket fargekode.',
    SET_DEFAULT_COLOR: 'Angi standardfargen',
    ANGLE: 'Vinkel',
    PRODUCT_NOT_AVAILABLE: 'Utgått, vennligst velg en annen serie',
    CALCULATE_PRICE_LINK: 'Beregn frakt her',
    MULLION_TYPES: 'Modell',
    SMOOTH: 'Glatt',
    DECOR: 'Innredning',
    BAR_TYPE: 'Type',
    FOLD_ON: 'Fold på',
    COLOR_WARNING: 'Fargen som vises på skjermen kan avvike noe fra virkeligheten',
    DOOR_INSIDE_OUTSIDE_COLOR_INFO: 'Det er kun mulig å velge samme farge på innsiden og utsiden, eller standard hvit på innsiden og valgfri farge på utsiden',
    FLASHING: "Takplater",
    ADDITIONAL_ACCESSORIES: "Valgfritt tilbehør",
    INCLUDED_ACCESSORIES: "Inkludert",
    WIDTH_DIMENSION_INFO: 'Breddemål: ',
    HEIGHT_DIMENSION_INFO: 'Høydemål: ',
    DIMENSIONS_CONTACT_INFO: 'Ring oss hvis du har spørsmål: 0431-37 14 00',
    GO_TO_PRODUCT: 'Gå til produkt',
    TO: 'Tom',
    U_VALUE: 'U-verdi',
    READ_MORE_ABOUT_THIS_SERIE: 'Les mer om denne serien',
    SHAPE_HEADER: 'Velg form',
    WARM: 'Varm kantlist',
    ALUMINIUM: 'Aluminium',
    GLAZING_SPACERS: 'Glaskant',
    GLAZING_SPACER_COLOR_CHANGE_INFO: 'Når du endrer farge, endres også fargen på varmkantlisten. Se under fanen Glaskassett.',
    HANDLE_INSIDE: "Innvendig håndtak",
    HANDLE_OUTSIDE: "Utvendig håndtak",
    BE_CREATIVE: 'Vær kreativ',
    STOCK_ITEM: 'Lagerbeholdning',
    FAST_DELIVERY: 'Rask levering',
    COLOR_RULE_NOTICE: 'Når produktet overskrider dimensjonene 4862x2600mm, kan vi ikke tilby mørke farger på grunn av risikoen for utvidelse i varmt vær og sollys',
    DIMENSION_RULE_NOTICE: 'Du har valgt en mørk farge som ikke er tilgjengelig i den valgte dimensjonen. Maksimumsmålene er 4862x2600 mm på grunn av risiko for utvidelse i varmt vær og sollys',
    DEFAULT_CONFIGURATIONS: "Standardforslag",
    DESIGN_YOURSELF: "Design selv",
    EXTERNAL_MUNTIN: "Utvendig sprosse",
    MIDDLEGLASS_MUNTIN: "Midtre glassfelt",
    IN_OUT_DUPLEX_MUNTIN: "Wieners barer",
    DESIGN_YOURSELF_DESCRIPTION_HEADER: "Lag ditt eget design med sprosse og midtstolpe",
    DESIGN_YOURSELF_DESCRIPTION: 'Velg selv om du vil bruke midtpost eller sprosser. Du kan selvfølgelig kombinere midtstolpe og sprosser ved å gå inn i den respektive kategorien.',
    MUNTINS_DESCRIPTION: 'Alle sprosser er utenpåliggende, demonterbare sprosser. Ved valg av aluminium er sprossene helt i aluminium og har samme farge på begge sider av sprossene som produktets utvendige farge. Denne typen sprosser er ikke tilgjengelig i to farger. For andre løsninger eller materialer, se "Design selv". Vær oppmerksom på at diagonale sprosser kun kan produseres som mellomliggende sprosser.',
    MULLIONS_BESKRIVELSE: "Midtstolpen er glassdelende og har en glatt innside. Midtstolpen er malt i samme farge som resten av konstruksjonen.",
    CLOSE: 'Lukk',
    MUNTIN_CHANGE_INFO: 'Når du endrer farge, endres også fargen på midtstolpen. Se i menyen under Ramme & Midtstolpe',
    MUNTIN_DIDNT_CHANGE_INFO: 'Vi fant dessverre ikke den riktige fargen for dine sprosser. Vennligst velg riktig farge manuelt under fanen Rails & Centre Post',
    READ_MORE: 'Les mer',
    REGULAR_PRICE: 'Forbrukerpris',
    NORMAL_PRIS: 'Siste laveste pris',
    INCLUDING_TAX: 'inkludert moms',
    EXCLUDING_TAX: "eksklusiv moms",
    VISUALIZATION_NOTICE: 'Tegningen er ikke i målestokk og er kun et eksempel på hvordan det kan se ut',
    GLAZING_RULE_NOTICE: 'Den valgte kombinasjonen av glasstyper er dessverre ikke mulig. Vennligst velg en annen kombinasjon eller kontakt oss for hjelp på 0431-37 14 00.',
    DIAGONAL_SETUP_RULE_NOTIFICATION: "Du har valgt en standard sprossekonfigurasjon som inneholder diagonale sprosser. Bare midtre sprosser er mulig i sprossekonfigurasjonen du har valgt.",
    ORNAMENT_GLASS_RULE_NOTICE: "Det er ikke mulig å kombinere sikkerhetsglass på innsiden med ornamenter på innsiden. Velg ett av alternativene.",
    GO_TO_CART: "Gå til kassen",
    PRODUCTS_ADDED_TO_SHOPPING_CART: "PRODUKTER ER LAGT TIL I HANDLEKURVEN",
    ADD_TO_CART_AND_CONTINUE: "Legg til i handlekurven og fortsett å handle",
    RECOMMEND_ADDING_ACCESSORIES: "Vi anbefaler å legge til følgende tilbehør",
    CONTROL_SIDE: "Plassering av kontrollene",
    BOX: 'Profil',
    FABRIC: 'Stoff og farge',
    TOP_LATH: 'Profil',
    LOUVRE: 'Lameller',
    BOTTOM_RAIL: 'Nedre håndtak',
    LATH: 'Profil',
    SHEATING: 'Materiale og farge',
    MONTAGE_TYPE: 'Type montering',
    DRIVE: 'Styring',
    STACKING_TYPE: 'Skjema',
    TOP_RAIL: 'Profil',
    CHAIN: 'Kjede',
    BASEMENT_WINDOW_RULE_NOTICE: 'Det er kun mulig å få hjul med den angitte dimensjonen. Hvis du ønsker å få håndtak, må du øke størrelsen.',
    MAX_DIMENSIONS_NOTICE: "Dimensjonene ble justert fordi det ikke er mulig å legge til farge i den valgte dimensjonen.",
    CONTACT_US_FOR_PRICE: "Kontakt oss for pris",
    CART_URL: 'handlekurv',
    CART_PAYMENT_INFO: 'Betale direkte eller delbetaling med Klarna.',
    CLICK_HERE: 'klikke her',
    JUMP_TO_CONFIGURATOR_LABEL: 'Hvis du vil konfigurere produktet ditt, kan du enkelt gjøre det ved å',
};
